import st from "lib/utils/index";
import { CompanyFullDecorator } from "lib/decorators/index";
import { serializeCompany } from "lib/utils/api/serializers";
import BaseRepository from "./BaseRepository";

export default new (class CompanyRepository extends BaseRepository {
  show() {
    return this.api
      .get(`/company`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((c) => new CompanyFullDecorator(c));
  }

  update(data, initialData, { useFormData = false } = {}) {
    let payload = {
      company: serializeCompany(data, initialData),
    };
    if (useFormData) {
      payload = st.api.toFormData(payload);
    }
    return this.api
      .put(`/company`, payload)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((c) => new CompanyFullDecorator(c));
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/CompanyRepository.js